import(/* webpackMode: "eager" */ "/vercel/path0/src/app/pharmacy/page.tsx");
